import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import throttle from "lodash/throttle";

import rootReducer from "../reducers";
import { loadState, saveState } from "../utils/localStorage";

const persistedState = loadState();

const store = createStore(rootReducer, persistedState, applyMiddleware(thunk));

store.subscribe(
  throttle(() => {
    saveState({
      login: store.getState().login,
    });
  }, 1000)
);

export default store;
